import { useState } from "react";
import { addSuggestion, SUGGESTION_CATEGORIES } from "../../js/api/suggestions";
import { useAuth } from "../../js/hooks/useAuth";

export default function SuggestionWidget({ compact = false }) {
  const { session, role } = useAuth();
  const [text, setText] = useState("");
  const [category, setCategory] = useState("ui");
  const [note, setNote] = useState("");

  if (!session || !["buyer", "seller", "agent", "broker"].includes(role)) {
    return null;
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (!text.trim()) return;
    addSuggestion({
      text,
      category,
      from_name: session.name || session.email || "Signed-in user",
      from_role: role,
      from_user_id: session.userId,
    });
    setText("");
    setNote("Thank you. The admin desk will see this on this device.");
  }

  return (
    <section className={`suggest-widget${compact ? " suggest-widget--compact" : ""}`}>
      <h3>Suggest an improvement</h3>
      <p className="muted">UI, checklist, messaging, calendar, files, or documents — whatever would help your desk.</p>
      <form onSubmit={handleSubmit}>
        <label className="field">
          <span className="field-label">Category</span>
          <select className="field-select" value={category} onChange={(event) => setCategory(event.target.value)}>
            {SUGGESTION_CATEGORIES.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </select>
        </label>
        <label className="field">
          <span className="field-label">Your note</span>
          <textarea
            className="field-textarea"
            rows={compact ? 3 : 4}
            value={text}
            onChange={(event) => setText(event.target.value)}
          />
        </label>
        <button type="submit" className="primary-btn">
          Send suggestion
        </button>
      </form>
      {note ? <p className="muted">{note}</p> : null}
    </section>
  );
}
